var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 81,
    viewBox: "0 0 90 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 31.5,
    r: 31.5,
    fill: "#D0FFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5327 26.8982H15.7626C12.3307 26.8982 9.5387 29.6898 9.5387 33.1221C9.5387 34.0445 10.2865 34.7919 11.2085 34.7919C12.1306 34.7919 12.8784 34.0445 12.8784 33.1221C12.8784 31.5315 14.1724 30.2379 15.7626 30.2379H38.5337C40.1243 30.2379 41.4183 31.5315 41.4183 33.1221V74.1093C41.4183 75.6999 40.1243 76.9935 38.5337 76.9935H15.7626C14.1724 76.9935 12.8784 75.6999 12.8784 74.1093C12.8784 73.1869 12.1306 72.4394 11.2085 72.4394C10.2865 72.4394 9.5387 73.1869 9.5387 74.1093C9.5387 77.5416 12.3307 80.3332 15.7626 80.3332H38.5337C41.9656 80.3332 44.758 77.5416 44.758 74.1093L44.7576 33.1221C44.7576 29.6898 41.9656 26.8982 38.5333 26.8982H38.5327Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3894 45.6882C13.0415 45.0358 13.0415 43.9787 12.389 43.3271C12.0629 43.001 11.6357 42.8378 11.2084 42.8378C10.7811 42.8378 10.3535 43.001 10.0274 43.3271L0.918941 52.4355C0.355132 52.9993 0.268811 53.8825 0.712171 54.5452C0.779261 54.6452 0.855771 54.7359 0.93934 54.8171C1.36582 55.2428 10.0273 63.9043 10.0273 63.9043C10.6794 64.556 11.7368 64.5572 12.3889 63.9043C13.0414 63.2526 13.0414 62.1952 12.3893 61.5432L6.13166 55.2855L24.8711 55.2855C25.7931 55.2855 26.5409 54.5381 26.5409 53.6157C26.5409 52.6933 25.7931 51.9459 24.8711 51.9459L6.13166 51.9459L12.3894 45.6882Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0623 27L57.5318 35.5304L53 30.7079",
    stroke: "#00DEA3",
    strokeWidth: 2.54206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessExitIcon);
export default __webpack_public_path__ + "static/media/success-exit-icon.8417186e8287ee88f9bfb32c5f55de80.svg";
export { ForwardRef as ReactComponent };